import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, map, Observable, throwError} from 'rxjs';
import {GridSearchRequest} from '../../../grid/models/grid-search-request.model';
import {TranslateService} from "@ngx-translate/core";


@Injectable()
export class ExportApi {

  constructor(private httpClient: HttpClient, private translationService: TranslateService) { }

  exportToHtml( searchRequest: GridSearchRequest, baseUrl: string, httpParams?: HttpParams): Observable<string> {
    const headers: HttpHeaders = new HttpHeaders({ 'Accept': 'text/html' });
    const url = `${baseUrl}exportToHtml`;
    return this.httpClient.post(url, searchRequest,
      { headers: headers, params: httpParams, responseType: 'text' }).pipe(
        map((response: string) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response, 'text/html');
          const thElements = doc.querySelectorAll('thead th');
          thElements.forEach(th => {
            th.textContent = this.translationService.instant(th.textContent);
          });
          const serializer = new XMLSerializer();
          response = serializer.serializeToString(doc);
          return response;
        }),
        catchError((error: HttpErrorResponse) => throwError(error)));
  }

}
